export const getExperienceAvailability = (lifeObject, now = new Date()) => {
  const status = lifeObject.lifecycle?.status || 'active';
  if (lifeObject.audience?.visibility === 'private') {
    return { available: false, reason: 'private' };
  }
  if (['draft', 'paused', 'archived'].includes(status)) {
    return { available: false, reason: status };
  }
  const startAt = lifeObject.lifecycle?.startAt;
  if (startAt && new Date(startAt) > now) {
    return { available: false, reason: 'upcoming', at: startAt };
  }
  const endAt = lifeObject.lifecycle?.endAt;
  if (status === 'expired' || (endAt && new Date(endAt) <= now)) {
    return { available: false, reason: 'expired', at: endAt };
  }
  return { available: true, reason: null };
};

export const availabilityMessage = ({ reason, at }) => {
  if (reason === 'private')
    return 'This experience is only available to its intended audience.';
  if (reason === 'upcoming')
    return `This experience begins ${new Date(at).toLocaleString()}.`;
  if (reason === 'expired') return 'This experience has ended.';
  if (reason === 'paused') return 'This experience is temporarily unavailable.';
  return 'This experience is not available right now.';
};
